import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { ActivatedRoute } from '@angular/router';
import { Subscription, forkJoin, take } from 'rxjs';
import { Contact } from 'src/app/common/models/contact';
import { GroupContact } from 'src/app/common/models/group-contact';
import { Person } from 'src/app/common/models/person';
import { StudyTitle } from 'src/app/common/models/study-title';
import { DetailsService } from 'src/app/common/services/details.service';
import { MatExpansionComponent } from '../mat-expansion.component';

@Component({
  selector: 'rpc-detail-contacts',
  templateUrl: './detail-contacts.component.html',
  styleUrls: ['./detail-contacts.component.scss']
})
export class DetailContactsComponent extends MatExpansionComponent implements OnInit, OnDestroy {

  irbNumber !: string;
  contactsList!: Contact[];
  roleBasedResults: GroupContact[] = [];
  public studyTitle !:StudyTitle;
  private subscriptionsList: Subscription[] = [];

  
  constructor(private route: ActivatedRoute, private detailsService: DetailsService) {
    super();
    this.irbNumber = this.route.parent?.snapshot.params['irbNumber'];
    this.studyTitle = this.detailsService.studyTitle;
   }

  ngOnInit(): void {
    const studyContacts$ = this.detailsService.getStudyContactsV2(this.irbNumber).pipe(take(1));
    const keyContacts$ = this.detailsService.getKeyContactsByIrbNumber(this.irbNumber).pipe(take(1));

    // Use forkJoin to make both calls in parallel and combine results
    const combinedSub = forkJoin([studyContacts$, keyContacts$]).subscribe({
      next: ([studyContacts, keyContacts]: [Contact[], Person[]]) => {
        this.contactsList = studyContacts;
        const sponsorRoles: GroupContact[] = [];
        const mayoClinicRoles: GroupContact[] = [];
        const otherRoles: GroupContact[] = [];

        this.contactsList.forEach(cont => {
          const mapValues = this.groupByRole(cont.personsList);
          let groupContact: GroupContact = { label: cont.label, mappedPerson: mapValues, isExpanded:true };
          const labelLower = cont.label.toLowerCase();
          if (labelLower.includes('sponsor roles')) {
            sponsorRoles.push(groupContact);
          } else if (labelLower.includes('mayo clinic roles')) {
            mayoClinicRoles.push(groupContact);
          } else {
            otherRoles.push(groupContact);
          }
        });

        // Build the ordered array: sponsor roles, key site contacts roles, mayo clinic roles, other roles if present
        let roleBasedResults: GroupContact[] = [];
        roleBasedResults = [...sponsorRoles];
        if (keyContacts && keyContacts.length > 0) {
          keyContacts.forEach(contact => { contact.role = contact.roleDescription ; contact.site = contact.locationAbbr });
          const mappedPerson = this.groupByRole(keyContacts);
          const keyContactGroup: GroupContact = { label: 'Key Site Contacts', mappedPerson, isExpanded: true };
          roleBasedResults.push(keyContactGroup);
        }
        roleBasedResults = [...roleBasedResults,  ...mayoClinicRoles, ...otherRoles];
        this.roleBasedResults = roleBasedResults;
      },
      error: () => {
        this.roleBasedResults = [];
      }
    });
    this.subscriptionsList.push(combinedSub);
  }

  groupByRole(personList: Person[]){  
   const map = new Map<string, Person[]>();
    personList.forEach(p => {
      const value = map.get(p.site ? p.role + '(' + p.site + ')' : p.role)
       if(!value) {
        map.set(p.site ? p.role + '(' + p.site + ')' : p.role , [p]);
       }else{
        value.push(p);
       }
    });
    return map;
  }

  /**
   * This is used on keyvalue pipe for perserving order since keyvalue is doing default sorting.
   * 
   * @param a 
   * @param b 
   * @returns 
   */
  asIsOrder(a:any, b:any) {
    return 1;
  }
  
  ngOnDestroy(): void {
    this.subscriptionsList.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

}
